import axios from '../api/axiosSetup3';
import { Plate } from '../types/plate';

// Чтение: Используем агрегацию через PostgREST
export const fetchPlates = async (): Promise<Plate[]> => {
  // const query = `*,reactions:lpr_plate_to_reaction(id)`;
  // const query = `*,reactions:lpr_plate_to_reaction(id),lpr_subtenant_to_group(subtenant_id)`;
  // Мы идем из plate в group, а из неё в subtenant_to_group
  const query = `*,reactions:lpr_plate_to_reaction(id),lpr_group(lpr_subtenant_to_group(subtenant_id))`;

  const { data } = await axios.get<any[]>('/lpr_plate', { 
    params: { 
      select: query,
      order: 'registration_number.asc'
    },
    headers: { 'Content-Type': 'application/json' }, 
  });
  
  return data.map(p => {
    // Достаем первый subtenant_id
    const firstSubtenant = p.lpr_group?.lpr_subtenant_to_group?.[0]?.subtenant_id;

    return {
    ...p,
      reactions: p.reactions.map((r: any) => r.id),
      subtenant_id: firstSubtenant,
    };
  });
};

interface ManagerResult {
  status: string;
  id: number;
}

// Атомарный CUD через RPC
export const upsertPlate = async (plate: Partial<Plate>): Promise<ManagerResult> => {
  const action = plate.id ? 'update' : 'create';
  const { data } = await axios.post('/rpc/sf_plate_manager_2', {
    p_action: action,
    p_data: plate
  });
  return data;
};

export const deletePlate = async (id: number): Promise<ManagerResult> => {
  const { data } = await axios.post('/rpc/sf_plate_manager_2', {
    p_action: 'delete',
    p_data: { id }
  });
  return data;
};

export const  api = {
  fetchPlates,
  upsertPlate,
  deletePlate
}